import $ from 'jquery';

/**
 * Serialize a form to object.
 * @return {Object}
 */
$.fn.serializeObject = function() {
	var o = {};
	var a = this.serializeArray();
	$.each(a, function() {
		if (o[this.name] !== undefined) {
			if (!o[this.name].push) {
				o[this.name] = [o[this.name]];
			}
			o[this.name].push(this.value || '');
		} else {
			o[this.name] = this.value || '';
		}
	});
	return o;
};

/**
 * Set unchecked
 * @return {void} [description]
 */
$.fn.uncheck = function() {
	if (this.is(':checked')) { return this.prop('checked', false).change() }
};

/**
 * Set checked
 * @return {void} [description]
 */
$.fn.check = function() {
	if (!this.is(':checked')) { return this.prop('checked', true).change() }
};